import {VisibilityLevel} from "../Analytics.type";

export const getRolesOptions = (visibilityLevel: VisibilityLevel) => {
  switch (visibilityLevel) {
    case 1:
      return ['field', 'area_manager', 'agent']
    case 2:
      return ['field', 'area_manager', 'agent']
    default:
      return ['agent']
  }
}

export const allUsers = ['registered', 'activated', 'user', 'adopter', 'promoter', 'churn', 'deleted', 'pending', 'never_registered']
export const initUsers = ['registered', 'activated', 'user', 'adopter', 'promoter', 'churn']